import React from 'react'

// Import dedicated styles for Grammarly at Work 25 component
import styles from './grammarly-at-work-25.module.scss'
import { TypeAssetImage } from '@lib/types/asset-image'

export interface GrammarlyAtWork25Props {
  title?: string
  description?: string
  image?: TypeAssetImage
}

/**
 * Grammarly at Work 25 Component - Static hero with title and Contentful image
 * Based on BTS Agents 25 but simplified for static content display
 */
const GrammarlyAtWork25Inner: React.FC<GrammarlyAtWork25Props> = ({
  title = "It's Grammarly like you've never seen—a new surface where your writing tools come together to work together.",
  description,
  image,
}) => {
  return (
    <div className={styles.mainContainer}>
      {/* Text Content Section */}
      <div className={styles.textContent}>
        <div className={styles.titleContainer}>
          <h2 className={styles.title}>{title}</h2>
        </div>
        {description && (
          <div className={styles.descriptionContainer}>
            <p className={styles.description}>{description}</p>
          </div>
        )}
      </div>

      {/* Image Section */}
      <div className={styles.imageContainer}>
        {image?.fields?.asset?.fields?.file && (
          <img
            src={image.fields.asset.fields.file.url}
            alt={image.fields.title || 'Grammarly at Work interface'}
            className={styles.grammarlyHeroImage}
            width={image.fields.asset.fields.file.details?.image?.width}
            height={image.fields.asset.fields.file.details?.image?.height}
          />
        )}
      </div>
    </div>
  )
}

export const GrammarlyAtWork25Component: React.FC<GrammarlyAtWork25Props> = (props) => {
  return <GrammarlyAtWork25Inner {...props} />
}
